import { BindingCreator } from '@dreryk/react-common';
import { Textarea } from '@dreryk/react-components';

import { referralTranslationKeys } from '../translations';

const EXAMINATIONS_PERFORMED_FIELD_NAME = 'examinationsAlreadyPerformed';
type ExaminationsPerformedFormBeanPart = {
   [EXAMINATIONS_PERFORMED_FIELD_NAME]: string | null;
};
type ExaminationsPerformedFieldProps = {
   readonly register: BindingCreator<ExaminationsPerformedFormBeanPart>;
};

export const ExaminationsPerformedTextarea = (props: ExaminationsPerformedFieldProps): JSX.Element => {
   return (
      <Textarea
         rows={3}
         maxRows={5}
         maxLength={3600}
         focus={false}
         label={referralTranslationKeys.examinationsAlreadyPerformed}
         controller={props.register(EXAMINATIONS_PERFORMED_FIELD_NAME)}
         placeholder={referralTranslationKeys.insertExaminationsAlreadyPerformed}
         testId={'examinationsPerformed'}
      />
   );
};
